import { getPatternStyles, patternFns } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const flexGridConfig = {
transform(props, { map, isCssUnit, isCssVar }) {
  const { container, columnSpacing, rowSpacing, ...rest } = props;
  const valueFn = (val) => {
    const escapedVal = val.replace(/^\[|\]$/g, "");
    return isCssUnit(escapedVal) || isCssVar(escapedVal) ? val : `token(spacing.${val}, ${val})`;
  };
  if (!container) {
    return {
      display: "flex",
      boxSizing: "border-box",
      minWidth: "[0]",
      ...rest
    };
  }
  const containerStyles = {
    display: "flex",
    flexWrap: "wrap",
    boxSizing: "border-box"
  };
  if (columnSpacing == null) {
    return {
      ...containerStyles,
      width: "[100%]",
      ...rest
    };
  }
  return {
    ...containerStyles,
    "--FlexGrid-columnSpacing": map(columnSpacing, valueFn),
    "--FlexGrid-rowSpacing": map(rowSpacing, valueFn),
    columnGap: columnSpacing,
    rowGap: rowSpacing,
    "& > *": {
      boxSizing: "border-box"
    },
    ...rest
  };
},
defaultValues:{container:false,rowSpacing:'0'}}

export const getFlexGridStyle = (styles = {}) => {
  const _styles = getPatternStyles(flexGridConfig, styles)
  return flexGridConfig.transform(_styles, patternFns)
}

export const flexGrid = (styles) => css(getFlexGridStyle(styles))
flexGrid.raw = getFlexGridStyle